import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Popup.css';

const TermsConditionsPopup = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const isSlovak = i18n.language === 'sk';

  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <h2>{t('terms_conditions')}</h2>
          <button className="popup-close" onClick={onClose}>×</button>
        </div>
        <div className="popup-content">
          {isSlovak ? (
            <div className="terms-conditions">
              <h3>Všeobecné obchodné podmienky</h3>
              
              <div className="terms-section">
                <h4>1. Identifikačné údaje prevádzkovateľa</h4>
                <ul>
                  <li>Obchodné meno / názov OZ: TiDea Solis</li>
                  <li>Sídlo: Andreja Cházára 909/2, 048 01 Rožňava</li>
                  <li>IČO: 55728472</li>
                  <li>Registrácia: registrované MV SR dňa 27.10.2023, číslo registrácie VVS/1-900/90-67375</li>
                  <li>Kontaktný e-mail: tideasolis@gmail.com Telefón: +421 907 510 511</li>
                </ul>
              </div>

              <div className="terms-section">
                <h4>2. Dozorný orgán</h4>
                <ul>
                  <li>Dozorná rada podľa zákona č. 213/1997 z.z. § 25</li>
                </ul>
              </div>

              <div className="terms-section">
                <h4>3. Predmet služby</h4>
                <p>Prevádzkovateľ poskytuje voľno-časové služby – lekcie jogy a tematické workshopy – v priestoroch jógového štúdia na adrese Andreja Cházára 909/2, 048 01 Rožňava. Popis, trvanie a kapacita jednotlivých lekcií sú uverejnené pri každej ponuke na webovej stránke. Konečné ceny sú uvedené v eurách vrátane všetkých daní a poplatkov.</p>
              </div>

              <div className="terms-section">
                <h4>4. Uzatvorenie zmluvy a rezervácia</h4>
                <ol>
                  <li>
                    Rezerváciu je možné vykonať:
                    <ul>
                      <li>prostredníctvom rezervačného formulára na webovej stránke,</li>
                      <li>e-mailom, telefonicky alebo prostredníctvom sociálnych sietí,</li>
                      <li>registrovaný používateľ môže rezervovať miesto aj pre tretiu osobu.</li>
                    </ul>
                  </li>
                  <li>Zmluva o poskytnutí služby vzniká okamihom doručenia potvrdenia rezervácie e-mailom alebo SMS.</li>
                </ol>
              </div>

              <div className="terms-section">
                <h4>5. Platobné podmienky</h4>
                <p>Úhrada sa realizuje na mieste pred začiatkom lekcie jedným z nasledovných spôsobov:</p>
                <ul>
                  <li>hotovosť,</li>
                  <li>MultiSport karta,</li>
                  <li>UpBalansea,</li>
                  <li>darčeková poukážka,</li>
                  <li>[ĎALŠIE METÓDY].</li>
                </ul>
                <p>Webová stránka neumožňuje online platby a neúčtuje rezervačný poplatok.</p>
              </div>

              <div className="terms-section">
                <h4>6. Zrušenie rezervácie a storno podmienky</h4>
                <table className="terms-table">
                  <thead>
                    <tr>
                      <th>Typ služby</th>
                      <th>Bezplatné zrušenie najneskôr</th>
                      <th>Spôsob zrušenia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bežná lekcia</td>
                      <td>12 hodín vopred</td>
                      <td>cez používateľský profil / e-mail / telefón</td>
                    </tr>
                    <tr>
                      <td>Workshop</td>
                      <td>24 hodín vopred</td>
                      <td>cez používateľský profil / e-mail / telefón</td>
                    </tr>
                  </tbody>
                </table>
                <p>Neskoré zrušenie alebo no-show sa eviduje; opakované porušenie môže viesť k dočasnému zablokovaniu prístupu do rezervačného systému.</p>
              </div>

              <div className="terms-section">
                <h4>7. Právo spotrebiteľa na odstúpenie</h4>
                <p>Keďže ide o službu súvisiacu s voľným časom poskytovanú v určenom termíne, spotrebiteľ nemá právo odstúpiť od zmluvy do 14 dní podľa § 7 ods. 6 písm. k) zákona č. 102/2014 Z. z.</p>
              </div>

              <div className="terms-section">
                <h4>8. Reklamačný poriadok</h4>
                <ul>
                  <li>Reklamáciu alebo sťažnosť je možné uplatniť písomne na adresu sídla alebo e-mailom na tideasolis@gmail.com</li>
                  <li>Prevádzkovateľ vybaví reklamáciu najneskôr do 30 dní od jej doručenia a informuje spotrebiteľa o výsledku.</li>
                </ul>
              </div>

              <div className="terms-section">
                <h4>9. Alternatívne riešenie sporov (ARS) a ODR</h4>
                <p>Spotrebiteľ má právo obrátiť sa na subjekt ARS alebo využiť platformu ODR (Online Dispute Resolution) na adrese https://ec.europa.eu/consumers/odr. Zoznam subjektov ARS je zverejnený na webovej stránke Ministerstva hospodárstva SR.</p>
              </div>

              <div className="terms-section">
                <h4>10. Zdravotné obmedzenia a zodpovednosť</h4>
                <p>Účastník cvičí na vlastné riziko. Osoby so zdravotnými ťažkosťami sú povinné uviesť špeciálne požiadavky v príslušnom poli rezervačného formulára a prípadne konzultovať svoj stav s lekárom. Prevádzkovateľ nezodpovedá za škody vzniknuté nedodržaním pokynov inštruktora.</p>
              </div>

              <div className="terms-section">
                <h4>11. Ochrana osobných údajov</h4>
                <p>Osobné údaje sa spracúvajú výlučne na účely rezervácie a komunikácie v súlade s GDPR. Podrobnosti sú uvedené v Zásadách ochrany osobných údajov dostupných na webovej stránke.</p>
              </div>

              <div className="terms-section">
                <h4>12. Zmeny podmienok</h4>
                <p>Prevádzkovateľ si vyhradzuje právo tieto VOP kedykoľvek upraviť. Nové znenie nadobúda účinnosť dňom zverejnenia na webovej stránke.</p>
              </div>

              <div className="terms-footer">
                <p>Odoslaním rezervácie potvrdzujete, že ste sa oboznámili s týmito VOP a súhlasíte s nimi.</p>
              </div>
            </div>
          ) : (
            <div className="terms-conditions">
              <h3>Terms and Conditions</h3>
              <p>This is the English version of the Terms and Conditions. Please switch to Slovak language to view the full terms.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPopup; 